import React from 'react'
import { useTranslation } from 'react-i18next'

export const BasketBoostSVG: React.VFC<{
  fill?: string
  id: string
  className?: string
  title?: string
  desc?: string
}> = ({ fill = '#fff', className, title, desc, id }) => {
  const { t } = useTranslation(['svgs'])
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      id={id}
      className={className}
    >
      <title id={`${id}Title`}>{title || t('basket_alt')}</title>
      {desc && <desc id={`${id}Desc`}>{desc}</desc>}
      <path fill="#fff" d="M0 11.754h3.825v1.153H0z"></path>
      <path
        fill={fill}
        fillRule="evenodd"
        d="m7.503.674-4.61 6.75-.887-.674L6.616 0zM10.87 0l4.504 6.57-.886.676L9.985.676z"
      ></path>
      <path fill={fill} d="M.546 4.262h16.395V7.72H.546z"></path>
      <path
        fill={fill}
        fillRule="evenodd"
        d="M1.592 8.873h14.304l-.471 5.954c-.094 1.195-1.042 2.114-2.178 2.114H4.24c-1.137 0-2.084-.919-2.178-2.114l-.061-.767h1.823v-1.153H1.911l-.091-1.153h6.377v-1.152H1.73zm4.42 5.187h-1.1v-1.153h1.1z"
      ></path>
    </svg>
  )
}
